import createReactComponent from '../createReactComponent';
export default createReactComponent('gender-bigender', 'IconGenderBigender', [
  ['path', { d: 'M11 11m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0', key: 'svg-0' }],
  ['path', { d: 'M19 3l-5 5', key: 'svg-1' }],
  ['path', { d: 'M15 3h4v4', key: 'svg-2' }],
  ['path', { d: 'M11 16v6', key: 'svg-3' }],
  ['path', { d: 'M8 19h6', key: 'svg-4' }],
]);
